import React from "react";
import { Col, Row } from "react-bootstrap";
const BankAccount = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: `bankaccountsection ${props.parentClass}` },
                    React.createElement("div", { className: "accountNumber" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray " }, props.sectionHeadleftTop),
                        React.createElement("span", { className: "DMSanM_14_500" }, props.sectionHeadleftBottom)),
                    React.createElement("div", { className: "bankname" },
                        React.createElement("span", { className: "DMSansNormal_12_400 txt_secondary-gray" }, props.sectionHeadRightTop),
                        React.createElement("span", { className: "DMSanM_14_500" },
                            props.hideIcon ? null : (React.createElement("i", { className: "edel-icon-zigzag pe-1 txt-orange-light" })),
                            props.sectionHeadRightBottom)))))));
};
export default BankAccount;
